import lazyLoading from './lazyLoading'

export default {
  name: 'HomeNet Parcel',
  path: '/homenet/parcel',
  redirect: '/homenet/parcel/info',
  meta: {
    auth: ['user'],
    icon: 'fas fa-cube',
    expanded: false
  },
  component: lazyLoading('homenet', true),
  children: [
    {
      'name': 'Delivery Info',
      'path': 'info',
      'meta': {
        'label': 'Delivery Info'
      },
      'component': lazyLoading('homenet/ParcelInfo')
    }
  ]
}



// WEBPACK FOOTER //
// ./client/store/modules/menu/parcel.js